import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
let LongContentContainer = class LongContentContainer extends Vue {
    constructor() {
        super(...arguments);
        this.contentHeight = 0;
        this.contentWrapperDom = null;
        this.contentDom = null;
        this.needExpand = false;
        this.isExpand = false;
        this.iterator = 0;
    }
    get formatHeight() {
        var _height = parseFloat(`${this.height}`);
        return isNaN(_height) ? 0 : _height;
    }
    mounted() {
        this.init();
    }
    init() {
        this.$nextTick(() => {
            if (this.iterator > 3)
                return;
            const contentWrapperEl = this.contentWrapper;
            const contentEl = this.$slots.content[0].elm;
            const contentHeight = contentEl.clientHeight;
            if (contentHeight !== 0) {
                this.contentHeight = contentHeight;
                if (this.contentHeight > this.formatHeight) {
                    this.needExpand = !0;
                    contentWrapperEl.style.height = this.formatHeight + "px";
                }
                console.log("pre load", contentHeight);
                var imgList = Array.from(contentWrapperEl.querySelectorAll("img"));
                const length = imgList.length;
                if (length) {
                    let counter = 0;
                    for (let c = 0; c < imgList.length; c++) {
                        const elm = imgList[c];
                        elm.onload = function () {
                            counter += 1;
                            elm.onload = null;
                        };
                        elm.onerror = function () {
                            counter += 1;
                            elm.onerror = null;
                        };
                    }
                    var interval = setInterval(() => {
                        if (length === counter) {
                            this.$emit("documentLoaded"),
                                clearInterval(interval);
                        }
                    }, 500);
                    this.$on("documentLoaded", () => {
                        var clientHeight = contentEl.clientHeight;
                        // console.log("after load", contentHeight)
                        if (clientHeight !== this.contentHeight) {
                            this.contentHeight = clientHeight;
                        }
                    });
                }
            }
            else
                setTimeout(() => {
                    this.iterator += 1,
                        this.init();
                }, 1000);
        });
    }
    handleContentChange() {
        const height = this.isExpand ? this.formatHeight : this.contentHeight + 32;
        this.contentWrapper.style.height = height + "px";
        this.isExpand = !this.isExpand;
    }
};
tslib_1.__decorate([
    Prop({ type: [Number, String], default: 300 })
], LongContentContainer.prototype, "height", void 0);
tslib_1.__decorate([
    Ref()
], LongContentContainer.prototype, "contentWrapper", void 0);
LongContentContainer = tslib_1.__decorate([
    Component({
        name: 'LongContentContainer',
    })
], LongContentContainer);
export default LongContentContainer;
